<div class="dashboard">
	<app-header></app-header>
	<router-outlet></router-outlet>
	<div class="container">
		<app-footer></app-footer>
	</div>
</div>